import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { GeneralInput } from "../presentational/general_text_input.jsx";
import { NumInput } from "../presentational/general_num_input.jsx";
import { ImageInput } from "../presentational/image_input.jsx";
import { AreaInput } from "../presentational/text_area_input.jsx";
import { DateInput } from "../presentational/date_input.jsx";
import SelectDropdown from "../presentational/select_dropdown.jsx";
import CheckList from "../presentational/check_list.jsx";
import { Stepper } from "../presentational/stepper.jsx";
import PlannerLead from "../presentational/planner_lead.jsx";
import { Step } from "../presentational/step.jsx";
import { NoteBox } from "../presentational/note_box.jsx";
import { KONE_PARTS_URL, EUROPE_PARTS_URL } from "../../assets/links";
import { EUROPE_EQUIPMENT_LOCATION_COUNTRY_CODES } from "../../assets/countryCodes";
import PreviousResponse from "../previous-response/previous_response.jsx";

import authService from "../../services/auth";

let sessionRefreshInterval = undefined;

export class SiteSurveyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  async componentDidMount() {
    await authService.verifyUserLoggedIn(true); // Ensuring that the session is refreshed on getting to the survey page

    sessionRefreshInterval = setInterval(async () => {
      await authService.verifyUserLoggedIn(true);
    }, 3000000); // Refresh call to be made after every 50 minutes (Timeout being 1 hour).
  }

  componentWillUnmount() {
    if (sessionRefreshInterval != undefined) {
      clearInterval(sessionRefreshInterval);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.previousFormState !== this.props.previousFormState) {
      this.setState({ previousFormState: this.props.previousFormState });
    }
  }

  valueOfField(fieldId) {
    if (this.props.formState[fieldId] == undefined) return undefined;

    return this.props.formState[fieldId].value;
  }

  getSharedSelectionOptionTranslations(field) {
    var tranlationsDictionary = {};
    field.options.forEach((key) => {
      var keyAsString = String(key);
      if (this.props.strings?.sharedSelectionOptions[keyAsString]) {
        tranlationsDictionary[keyAsString] =
          this.props.strings?.sharedSelectionOptions[keyAsString];
      }
    });
    if (Object.keys(tranlationsDictionary).length !== field.options.length) {
      console.error("Could not find translations");
      console.error("Translations that script was looking for:");
      console.error(field.options);
      console.error("Shared selection options:");
      console.error(this.props.strings?.sharedSelectionOptions);
      return null;
    }
    return tranlationsDictionary;
  }

  getStrings(field) {
    let translationString = this.props.strings?.options?.[field.id];
    if (translationString === undefined) {
      translationString = this.getSharedSelectionOptionTranslations(field);
    }
    return translationString;
  }

  onBoxChecked(value) {
    this.props.onBoxChecked(value);

    this.setState({
      [value]: this.state[value] ? false : true,
    });
  }

  conditionsMet(field = {}) {
    const { requiresCheckBox, notAllowedCheckBox, selectionConditionId, selectionConditions } = field;
    const state = this.state || {};
    const formState = this.props?.formState || {};

    if (Array.isArray(requiresCheckBox) && !requiresCheckBox.every(cb => state[cb])) {
      return false;
    }

    if (Array.isArray(notAllowedCheckBox) && notAllowedCheckBox.some(cb => state[cb])) {
      return false;
    }

    if (selectionConditionId && Array.isArray(selectionConditions)) {
      const value = formState[selectionConditionId]?.value;
      return selectionConditions.includes(value);
    }

    return true;
  }

  getPreviews(id) {
    if (this.props.formState[id] && this.props.formState[id].images)
      return this.props.formState[id].images;
    else return null;
  }

  getLeadFromPreviousSurvey(field) {
    const id = field.selectionConditionId || field.checkBoxSelectionId;
    // Init new Planner Lead (needed for mandatory field checks)
    /* if (!this.props.previousPlannerLeads[id]) {
      this.props.onPlannerLeadChanged(id, "init", null);
    } */
    return this.props.previousPlannerLeads[id]
      ? this.props.previousPlannerLeads[id]
      : null;
  }

  getCorrectLead(field) {
    const id = field.selectionConditionId || field.checkBoxSelectionId;
    // Init new Planner Lead (needed for mandatory field checks)
    if (!this.props.plannerLeads[id]) {
      this.props.onPlannerLeadChanged(id, "init", null);
    }
    return this.props.plannerLeads[id] ? this.props.plannerLeads[id] : null;
  }

  plannerLeadVisible(field) {
    const conditionId = field?.selectionConditionId;
    const conditions = field?.selectionConditions;
    let plannerLeadShouldBeVisible =
      this.props.formState?.[conditionId]?.value &&
      conditions &&
      Array.isArray(conditions) &&
      conditions.indexOf(this.props.formState?.[conditionId]?.value) > -1
        ? true
        : false;
    if (
      field?.isOlderThanYears &&
      this.props.formState?.[field.selectionConditionId]?.value &&
      this.props.formState?.[field.selectionConditionId]?.value.toString()
        .length === 4
    ) {
      const yearDifference =
        new Date().getFullYear() -
        Number(this.props.formState?.[field.selectionConditionId]?.value);
      plannerLeadShouldBeVisible = yearDifference > field.isOlderThanYears;
    }
    return plannerLeadShouldBeVisible;
  }

  getPSRpackageLink() {
    const equipment = this.props.equipment;
    if (
      equipment &&
      EUROPE_EQUIPMENT_LOCATION_COUNTRY_CODES.includes(
        equipment.EquipmentLocationCompanyCode,
      )
    ) {
      return EUROPE_PARTS_URL;
    }
    return KONE_PARTS_URL;
  }

  render() {
    return (
      <div>
        <Stepper
          conditionsMet={this.conditionsMet.bind(this)}
          disabled={this.props.disabled}
          formState={this.props.formState}
          strings={this.props.commonStrings}
        >
          {(() => {
            const props = this.props || {};

            const {
              formLayout = [],
              strings = {},
              commonStrings = {},
              formState = {},
              previousFormState = {},
              plannerLeadsStrings = {},
              showCheckBoxes,
              onValueChange,
              onImageDrop,
              onImageClicked,
              onPlannerLeadChanged,
            } = props;

            const fieldsStrings = strings.fields || {};
            const stepTitles = strings.stepTitles || {};
            const checkBoxesStrings = strings.checkBoxes || {};
            const sharedSelectionOptions = strings.sharedSelectionOptions || {};

            const lastSurveyResponseHeader =
              commonStrings.lastSurveyResponse || "Last survey response:";

            const checkBoxOptions = Object.keys(checkBoxesStrings)
              .filter((key) =>
                [
                  "hasBeenModernized",
                  "hasMachineRoom",
                  "isHydraulicElevator",
                  "hasInverterDrive",
                  "hasGearedMachine",
                ].includes(key),
              )
              .map((key) => ({
                text: checkBoxesStrings[key],
                key,
              }));

            return formLayout.map((stepItem, stepIndex) => (
              <Step
                key={stepItem?.step || stepIndex}
                stepItem={stepItem}
                title={stepTitles?.[stepItem?.step] || ""}
              >
                <div className="input-form">
                  {(stepItem?.fields || []).map((field, fieldIndex) => {
                    if (!field?.id) return null;

                    const fieldState = formState?.[field.id] || {};
                    const prevState = previousFormState?.[field.id];

                    const fieldValue = fieldState?.value ?? "";
                    const fieldLabel = fieldsStrings?.[field.id] || "";

                    let previousResponse = prevState?.value ?? null;
                    let previousResponseText = previousResponse;

                    if (field.type === "dropdown" && field.options?.length) {
                      const dropdownStrings = this.getStrings?.(field) || {};
                      previousResponseText =
                        dropdownStrings?.[previousResponse] ?? previousResponse;
                    }

                    if (fieldState?.hidden) return null;
                    if (!this.conditionsMet?.(field)) return null;

                    switch (field.type) {
                      case "dropdown": {
                        const dropdownStrings = this.getStrings?.(field) || {};
                        const showConditionalHint = field.conditionalHelpText &&
                          formState[field.id]?.value === field.conditionalHelpText.whenValue &&
                          !formState[field.conditionalHelpText.dependsOnField || 'landingDoor']?.value;

                        return (
                          <div key={`dropdown-wrapper-${field.id}`}>
                          <SelectDropdown
                            key={`dropdown-${field.id}`}
                            id={field.id}
                            strings={dropdownStrings}
                            title={fieldLabel}
                            value={fieldState || ""}
                            options={field.options || []}
                            mandatory={
                              field.conditionalMandatory
                                ? formState[field.conditionalMandatory.dependsOn]?.value === field.conditionalMandatory.whenValue
                                : (field.mandatory || false)
                            }
                            onValueChange={(valueObj) =>
                              onValueChange?.(field, valueObj)
                            }
                            default={strings?.selectValue || ""}
                            enableClearSelection={Boolean(field.enableClearSelection)}
                            clearSelectionText={sharedSelectionOptions?.CLEAR ?? null}
                            other={{
                              otherOption: field.otherOption,
                              otherText: strings?.other || "",
                              otherField: field.otherField,
                              otherFieldTitle: strings?.otherWhat || "",
                            }}
                            lastSurveyResponseHeader={lastSurveyResponseHeader}
                            lastSurveyResponseText={previousResponseText}
                          />
                          {showConditionalHint && (
                            <NoteBox
                              data={[{ text: fieldsStrings?.[field.conditionalHelpText.translationKey] || 'Please ensure "Landing door" type is selected above. It is required when door closing needs repair.' }]}
                              theme="help"
                            />
                          )}
                          </div>
                        );
                      }

                      case "conditionalComponent": {
                        const isPlannerLead =
                          field.component === "planner-lead";
                        const isVisible = this.plannerLeadVisible?.(field);

                        if (!isPlannerLead || !isVisible) return null;

                        const selection =
                          field.selectionConditionId ||
                          field.checkBoxSelectionId ||
                          null;

                        return (
                          <PlannerLead
                            key={`planner-${selection || field.id || fieldIndex}`}
                            id={field.id}
                            onPlannerLeadChanged={(selection, type, value) =>
                              onPlannerLeadChanged?.(selection, type, value)
                            }
                            previousPlannerLead={
                              this.getLeadFromPreviousSurvey?.(field) ?? null
                            }
                            plannerLead={
                              this.getCorrectLead?.(field) ?? null
                            }
                            psrPackageUrl={
                              this.getPSRpackageLink?.() ?? null
                            }
                            selection={selection}
                            translations={plannerLeadsStrings}
                            responseHeader={lastSurveyResponseHeader}
                            relatedQuestionTranslation={
                              fieldsStrings?.[field.selectionConditionId] || null
                            }
                          />
                        );
                      }

                      case "date":
                        return (
                          <DateInput
                            key={`date-${field.id}`}
                            label={fieldLabel}
                            onValueChange={(valueObj) =>
                              onValueChange?.(field, valueObj)
                            }
                            initValue={fieldValue}
                            lastSurveyResponseHeader={lastSurveyResponseHeader}
                            lastSurveyResponseText={previousResponseText}
                          />
                        );

                      case "number":
                        return (
                          <React.Fragment key={`number-${field.id}`}>
                            {Number(previousResponseText?.quantity ?? 0) > 0 && (
                              <PreviousResponse
                                responseHeader={lastSurveyResponseHeader}
                                responseText={previousResponseText}
                              />
                            )}
                            <NumInput
                              id={field.id}
                              label={fieldLabel}
                              min={field.min}
                              max={field.max}
                              units="METRIC"
                              labelDetail={field.label}
                              maxLength={field.maxLength}
                              onInputChange={(valueObj) =>
                                onValueChange?.(field, valueObj)
                              }
                              value={fieldValue}
                              valid={Boolean(fieldState?.valid)}
                              validityTester={
                                field.validityRegExp
                                  ? (input) => field.validityRegExp.test(input)
                                  : null
                              }
                              helpText={
                                field.helpText
                                  ? fieldsStrings?.[field.helpText] || null
                                  : null
                              }
                            />
                          </React.Fragment>
                        );

                      case "text":
                        return (
                          <React.Fragment key={`text-${field.id}`}>
                            {previousResponseText && (
                              <PreviousResponse
                                responseHeader={lastSurveyResponseHeader}
                                responseText={previousResponseText}
                              />
                            )}
                            <GeneralInput
                              id={field.id}
                              label={fieldLabel}
                              onInputChange={(value) =>
                                onValueChange?.(field, { value })
                              }
                              value={fieldValue}
                            />
                          </React.Fragment>
                        );

                      case "image": {
                        const uploadSuccessful =
                          fieldState?.image?.uploadSuccesfull ?? true;

                        return (
                          <ImageInput
                            key={`image-${field.id}`}
                            id={field.id}
                            title={field.showTitle ? fieldLabel : null}
                            onDrop={(files) =>
                              onImageDrop?.(files, field.id)
                            }
                            mandatory={field.id === "carPictureCopKen"}
                            previews={this.getPreviews?.(field.id) || []}
                            label={strings?.selectImage || ""}
                            helpText={
                              field.helpText
                                ? fieldsStrings?.[field.helpText] || null
                                : null
                            }
                            addImageButtonText={commonStrings?.addImage || ""}
                            imgHelptext={
                              commonStrings?.imageFromLastSurvey || ""
                            }
                            uploadSuccessful={uploadSuccessful}
                            failText={strings?.imageUpload?.fail || ""}
                            instructionText={
                              field.instructionText
                                ? fieldsStrings?.[field.instructionText] || null
                                : null
                            }
                            onImageClick={(image, fieldId) =>
                              onImageClicked?.(image, fieldId)
                            }
                          />
                        );
                      }

                      case "text-area":
                        return (
                          <React.Fragment key={`textarea-${field.id}`}>
                            {previousResponseText && (
                              <PreviousResponse
                                responseHeader={lastSurveyResponseHeader}
                                responseText={previousResponseText}
                              />
                            )}
                            <AreaInput
                              id={field.id}
                              label={
                                field.translationKey
                                  ? fieldsStrings?.[field.translationKey] || ""
                                  : fieldLabel
                              }
                              helpText={
                                field.helpText
                                  ? fieldsStrings?.[field.helpText] || null
                                  : null
                              }
                              onInputChange={(value) =>
                                onValueChange?.(field, { value })
                              }
                              value={fieldValue}
                              maxLength="2000"
                            />
                          </React.Fragment>
                        );

                      case "checkboxes":
                        return showCheckBoxes ? (
                          <CheckList
                            key={`checkbox-${field.id || fieldIndex}`}
                            options={checkBoxOptions}
                            onBoxChecked={(value) =>
                              this.onBoxChecked?.(value)
                            }
                          />
                        ) : null;

                      default:
                        return null;
                    }
                  })}
                </div>
              </Step>
            ));
          })()}
        </Stepper>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(null, mapDispatchToProps)(SiteSurveyForm);
